import React from 'react';
import { Tooltip } from 'e100-react-components';
import { Icon } from 'components';

import useStyles from './useStyles';
import { useTextColor, useButtonText } from '../../../hooks';

import { LocationButtonProps } from '../EBoxLocationButton';
import { getColorNavigateItem, NavigateItem } from 'entities/application';
import { useHasCarEBoxLocations } from 'entities/cars';

export const EBoxLocationTabletButton = ({ onClick }: LocationTabletButtonProps) => {
  const textColor = useTextColor();
  const classes = useStyles({ textColor });
  const buttonText = useButtonText();
  const hasCarEBoxLocations = useHasCarEBoxLocations();

  return (
    <Tooltip title={buttonText}>
      <NavigateItem
        icon={<Icon kind="auto" style={{ color: getColorNavigateItem(hasCarEBoxLocations) }} />}
        //@ts-ignore
        onClick={onClick}
        selected={hasCarEBoxLocations}
        classes={{
          iconRoot: classes.iconRoot,
        }}
      />
    </Tooltip>
  );
};

interface LocationTabletButtonProps extends Pick<LocationButtonProps, 'onClick'> {}
